import React, { Component } from "react";
import { connect } from "react-redux";
import ValidationForm from "../components/validation/ValidationForm";
import ErrorAlert from "../components/structure/ErrorAlert";
import ResultContainer from "./ResultContainer";
import moment from "moment-timezone";
import {
  insertDataMasterOnSessionStorage,
  checkForSessionStorageSupport,
} from "../utils/verifier.utils.js";
import History from "../components/history/History";
import {
  fetchValidation,
  fetchBuyerTypes,
  fetchAccesses,
  fetchExtras,
  fetchPromotions,
  fetchVenueCapacities,
  fetchEvents, openShelly, fetchClient,
} from "../login/api.actions";
import { Overlay } from "clorian-frontend-components";
import { FormattedMessage } from "react-intl";
import playSound from "../utils/sounds.utils";
import displayValidation from "../utils/display.utils";

class ValidationContainer extends Component {
  constructor(props) {
    super(props);
    this.handleTicketValidation = this.handleTicketValidation.bind(this);
    this.handleForceValidation = this.handleForceValidation.bind(this);
    this.handleErrorValidation = this.handleErrorValidation.bind(this);
    this.handleCloseErrorValidation = this.handleCloseErrorValidation.bind(
      this
    );
    this.forceRefresh = this.forceRefresh.bind(this);
    this.handleSetVerifierId = this.handleSetVerifierId.bind(this);
    this.getNewDataMaster = this.getNewDataMaster.bind(this);

    this.state = {
      autoIncrementValidation: 0,
      buyerTypes: [],
      showErrorAlert: false,
      errorToShow: {},
      forceRefresh: false,
      verifierId: 0,
      loading: false,
    };
  }

  componentDidMount() {
    checkForSessionStorageSupport();
    const { dispatch } = this.props;
    const clientId = JSON.parse(sessionStorage.getItem("verifier"))
        .clientId;

    dispatch(fetchClient(clientId)).then(({response}) => {
      sessionStorage.setItem('timeZone', JSON.stringify(response.timeZone));
      this.getNewDataMaster("");
    })
  }

  forceRefresh(type) {
    this.setState({
      forceRefresh: true,
    });

    this.getNewDataMaster(type);
  }

  render() {
    const {
      currentValidation,
      errorToShow,
      showErrorAlert,
      loading,
      barcode,
    } = this.state;

    const verifierId = JSON.parse(sessionStorage.getItem("verifier"))
      .verifierId;

    return (
      <div className="verifier">
        <Overlay loading={loading} />

        <div>
          {showErrorAlert && (
            <div className="row">
              <div className="col-md-12">
                <ErrorAlert
                  error={errorToShow}
                  closeError={() => this.handleCloseErrorValidation()}
                />
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-8">
              <ValidationForm
                ticketValidation={this.handleTicketValidation}
                verifierId={verifierId}
              />

              {currentValidation && (
                <ResultContainer
                  forceValidation={this.handleForceValidation}
                  currentValidation={currentValidation}
                  barcode={barcode}
                  verifierId={verifierId}
                />
              )}
            </div>

            <div className="col-md-4 col-xs-12">
              <History
                currentValidation={currentValidation}
                barcode={barcode}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  /*  calculate the sound to play based on result code on item
   *   Now, if item have only one result 200 or 203, return to play ok
   */
  checkResultCode(playOk, item) {
    return playOk ||
      (!playOk && (item.resultCode === 200 || item.resultCode === 203))
      ? true
      : false;
  }

  getNewDataMaster(dataMasterType) {
    const datatTypeActions = {
      buyertypes: fetchBuyerTypes,
      extras: fetchExtras,
      promotions: fetchPromotions,
      accesses: fetchAccesses,
      venuecapacities: fetchVenueCapacities,
      events: fetchEvents,
    };

    const dataType = dataMasterType.toLowerCase();

    if (datatTypeActions[dataType]) {
      this._handleFetch(dataType, datatTypeActions[dataType]);
    } else {
      for (let type of Object.keys(datatTypeActions)) {
        this._handleFetch(type, datatTypeActions[type]);
      }
      this.setState({
        forceRefresh: true,
      });
    }
  }

  _handleFetch(dataType, fetchAction) {
    const { dispatch } = this.props;
    if (sessionStorage.getItem(dataType) === null || this.state.forceRefresh) {
      if (dataType === "events") {
        const timeZone = JSON.parse(sessionStorage.getItem("timeZone"));
        dispatch(fetchAction(moment().tz(timeZone).format("YYYY-MM-DD"))).then(
          ({ response }) => {
            this.setState({
              [dataType]: [...response],
              loading: false,
            });
            insertDataMasterOnSessionStorage(
              dataType,
              response,
              this.state.forceRefresh
            );
          }
        );
      } else {
        dispatch(fetchAction()).then(({ response }) => {
          if (response) {
            this.setState({
              [dataType]: [...response] || [],
              loading: false,
            });
            insertDataMasterOnSessionStorage(
              dataType,
              response || [],
              this.state.forceRefresh
            );
          } else {
            this.setState({
              [dataType]: [],
              loading: false,
            });
            insertDataMasterOnSessionStorage(
              dataType,
              [],
              this.state.forceRefresh
            );
          }
        });
      }
    }
  }

  handleTicketValidation(validationRequest) {
    const { dispatch } = this.props;
    const handleErrorValidation = this.handleErrorValidation;

    this.setState({
      loading: true,
    });

    //If is number(ticketId) has to be max 10 of length
    if (
      validationRequest.ticketId &&
      validationRequest.ticketId.toString().length > 10
    ) {
      handleErrorValidation({
        exception: "Error en la búsqueda",
        errorCode: "400",
        message: (
          <FormattedMessage
            defaultMessage="El código introducido no es válido"
            id="error.not.valid.code"
          />
        ),
      });
    } else {
      dispatch(fetchValidation(validationRequest)).then((response) => {
        //Put sound ko as default
        let playOk = false;
        let buyerTypeId = null;
        let promotionId = null;
        const verifierProps = JSON.parse(sessionStorage.getItem("currentConfiguration"))

        if (response && response.response && response.response.length > 0) {
          response.response.forEach((item, index) => {
            playOk = this.checkResultCode(playOk, item);
            buyerTypeId = item.buyerTypeId;
            promotionId = item.promotionId;
            response.response[index].barcode = validationRequest.barcode;
          });

          this.setState({
            currentValidation: response.response,
            barcode: validationRequest.barcode,
            autoIncrementValidation: this.state.autoIncrementValidation + 1,
            showErrorAlert: false,
          });

          if(verifierProps.validationEndpoint && playOk){
              dispatch(openShelly(verifierProps.validationEndpoint))
          }
        } else {
          if (response) {
            handleErrorValidation(response.error);
          }
        }

        //play the correct sound
        playOk ? playSound("ok", buyerTypeId, promotionId) : playSound("ko");

        //display in second screen (display tab)
        playOk ? displayValidation("ok") : displayValidation("ko");
      }).finally(()=>{
        this.setState({
          loading: false,
        });
      });
    }
  }

  handleForceValidation(validationRequest) {
    this.handleTicketValidation(validationRequest);
  }

  handleErrorValidation(error) {
    console.log("Error " + error);

    this.setState({
      loading: false,
      showErrorAlert: true,
      currentValidation: null,
      errorToShow: {
        title: error.exception || "Error en la búsqueda",
        code: error.errorCode || "400",
        message: error.message || (
          <FormattedMessage
            defaultMessage="El código introducido no es válido"
            id="error.not.valid.code"
          />
        ),
      },
    });
  }

  handleCloseErrorValidation(e) {
    this.setState({ showErrorAlert: false });
  }

  handleSetVerifierId(verifierId) {
    this.setState({
      verifierId: verifierId,
    });
  }
}

export default connect()(ValidationContainer);
